/** @jsx jsx */
import { jsx } from "@emotion/react";
import { useHistory } from "react-router";
import { Tooltip } from "@material-ui/core";
import { ArrowBack, detailNavContainerCss, pageNameCss } from "./styles";
import Notifications from "../../RightSection/Notifications";

export type DetailNavProps = {
  activePageName: string;
};

const DetailNav = ({ activePageName }: DetailNavProps) => {
  const { push } = useHistory();
  return (
    <div css={detailNavContainerCss}>
      <ArrowBack onClick={() => push("/")} />
      <Tooltip title={activePageName}>
        <span css={pageNameCss}>{activePageName}</span>
      </Tooltip>
      <Notifications />
    </div>
  );
};

export default DetailNav;
